import React, { useState } from 'react';
import GeneralComments from 'components/molecules/general-comments';
import { ModuleType } from 'infrastructure/enums';
import { isRpmModule } from 'infrastructure/functions';
import { useCheckPatientModule } from 'infrastructure/hooks/patient/use-check-patient-module';

import s from './styles.module.scss';

interface IProps {
  patientGuid: string;
}

const CallDashboardGeneralCommentsTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  const [tabModule, setTabModule] = useState<ModuleType>(ModuleType.RPM);

  const { isBlockCcmModule, isBlockRpmModule } =
    useCheckPatientModule(patientGuid);

  const blockEditing = isRpmModule(tabModule)
    ? isBlockRpmModule
    : isBlockCcmModule;

  return (
    <div>
      <GeneralComments
        className={s['general-comments']}
        withSwitcher
        patientGuid={patientGuid}
        module={ModuleType.RPM}
        onTabChange={setTabModule}
        readOnly={blockEditing}
      />
    </div>
  );
};

export default CallDashboardGeneralCommentsTab;
